export const KpiCard = ({ icon: Icon, label, value, children, testId, delay = 0 }) => (
  <div
    data-testid={testId}
    style={{ animationDelay: `${delay}ms` }}
    className="animate-rise group relative overflow-hidden rounded-lg bg-[#131f37] border border-[#1e293b] p-5 transition-[border-color,transform] duration-300 hover:border-amber-500/40 hover:-translate-y-0.5"
  >
    <span className="absolute left-0 top-5 bottom-5 w-0.5 bg-amber-500/70" />
    <div className="flex items-center justify-between">
      <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">{label}</p>
      <div className="h-8 w-8 rounded-md bg-amber-500/10 grid place-items-center">
        <Icon className="h-4 w-4 text-amber-500" />
      </div>
    </div>
    <p className="mt-4 font-mono text-3xl font-bold text-slate-50 tracking-tight" data-testid={`${testId}-value`}>
      {value}
    </p>
    <div className="mt-3 text-xs text-slate-400">{children}</div>
  </div>
);

export const Stat = ({ color, label, value, testId }) => (
  <span className="inline-flex items-center gap-1.5 mr-3" data-testid={testId}>
    <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
    {label} <b className="font-mono text-slate-200">{value}</b>
  </span>
);
